<template>
    <vue-modal
        v-model="isVisible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :closable="false"
        :modalBodyClass="$prefixClass.modal + '-trial-ended text-center'"
    >
        <img class="m-b-24" src="@/assets/images/block-trial.svg" alt=""/>
        <h4 class="m-b-8"> {{ $t('app.trial_premium_feature.block_title') }}</h4>
        <div class="m-b-24">
            <span v-html="$t('app.trial_premium_feature.block_description')"></span>
            <!-- <a class="a-link" href="" target="_blank"> {{ $t('app.buttons.learn_more') }}</a> -->
        </div>
        <div>
            <a-button class="m-b-8" type="primary" @click="upgrade"> {{ $t('app.buttons.upgrade_now') }}</a-button>
            <br><a-button class="text-color-secondary" type="subtle" @click="later"> {{ $t('app.buttons.maybe_later') }}</a-button>
        </div>
    </vue-modal>
</template>
<script>
import cookie from 'js-cookie'
export default {
    name: 'VueModalTrialEnded',
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {

        }
    },
    computed: {
        isVisible: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        later() {
            this.isVisible = false
            cookie.set('close-modal-trial-ended', true, { expires: 30 * 12 } )
        },
        upgrade() {
            this.later()
            cookie.set('close-modal-trial-ended', true, { expires: 30 * 12 } )
            this.$router.push({name: this.$routerName.PRICING})
        }
    }
}
</script>
<style lang="scss">
    .m-modal-trial-ended {
        width: 684px !important;
        .m-modal {
            &-body {
                padding: 32px 0;
            }
        }
    }
</style>